import React, { useRef, ChangeEvent } from 'react';
import { Button } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { useStyles } from './AppButtonUploadFile.styles';
import theme from '../../../styles/theme';

interface IAppButtonUploadFileProps {
  onFileInput?: (event: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

export default function AppButtonUploadFile({
  onFileInput,
  disabled,
}: IAppButtonUploadFileProps) {
  const fileUploadButtonRef = useRef<HTMLInputElement | null>(null);
  const { classes } = useStyles(theme);

  return (
    <>
      <Button
        component="label"
        className={classes.uploadFileButton}
        disableRipple
        onClick={() => fileUploadButtonRef.current?.click()}
        disabled={disabled}>
        <AttachFileIcon />
      </Button>
      <input
        ref={fileUploadButtonRef}
        autoComplete="off"
        multiple
        style={{ display: 'none' }}
        tabIndex={-1}
        type="file"
        onChange={onFileInput}
      />
    </>
  );
}
